import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";

import GridItem from "components/Grid/GridItem.js";

import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { API_BASE_URL } from "views/api"
import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
});

const ward_name_map = {
  'a': 'वडा नं १',
  'b': 'वडा नं २',
  'c': 'वडा नं ३',
  'd': 'वडा नं ४',
  'e': 'वडा नं ५',
  'f': 'वडा नं ६',
  'g': 'वडा नं ७',
  'h': 'वडा नं ८',
  'i': 'वडा नं ९',
  'j': 'वडा नं १०',
  'k': 'वडा नं ११',
  'l': 'वडा नं १२',
}

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();

  return (
    <React.Fragment>
      <TableRow className={classes.root}onClick={() => setOpen(!open)} style={{ cursor: 'pointer' }}>
        <TableCell component="th" scope="row">
          {row.ward},
        </TableCell>
        <TableCell>
          पदाधिकारीहरु <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        {/*<TableCell>वडा सचिबः {row.contact_person}</TableCell>*/}
        <TableCell>कार्यालय ठेगानाः {row.location},</TableCell>
        <TableCell style={{fontFamily: 'nepali-font'}}>सम्पर्क नं.: <span>{row.contact_number}</span></TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              {/*<Typography variant="h6" gutterBottom component="div">
                {row.ward}
              </Typography>*/}
              <GridContainer style={{ backgroundColor: '#fff', margin: '10px' }}>
                <GridItem xs={8} sm={4} md={2} style={{ marginLeft: 'auto', marginRight: 'auto', fontFamily: 'nepali-font' }}>
                  <Card style={{
                    marginBottom: '0', height: '100px',
                    backgroundColor: 'grey', backgroundImage: "url(" + row.ward_chief_photo + ")",
                    backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}
                  />
                  <div style={{ padding: '10px' }}>
                    <div>{row.ward_chief_name}</div>
                    <div><b>वडा अध्यक्ष</b></div>
                    <div><b>सम्पर्क नः </b>{row.ward_chief_contact}</div>
                  </div>
                </GridItem>
                <GridItem xs={8} sm={4} md={2} style={{ marginLeft: 'auto', marginRight: 'auto', fontFamily: 'nepali-font' }}>
                  <Card style={{
                    marginBottom: '0', height: '100px',
                    backgroundColor: 'grey', backgroundImage: "url(" + row.ward_member_1_photo + ")",
                    backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}
                  />
                  <div style={{ padding: '10px' }}>
                    <div>{row.ward_member_1_name}</div>
                    <div><b>सदस्य</b></div>
                    <div><b>सम्पर्क नः </b>{row.ward_member_1_contact}</div>
                  </div>
                </GridItem>
                <GridItem xs={8} sm={4} md={2} style={{ marginLeft: 'auto', marginRight: 'auto', fontFamily: 'nepali-font' }}>
                  <Card style={{
                    marginBottom: '0', height: '100px',
                    backgroundColor: 'grey', backgroundImage: "url(" + row.ward_member_2_photo + ")",
                    backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}
                  />
                  <div style={{ padding: '10px' }}>
                    <div>{row.ward_member_2_name}</div>
                    <div><b>सदस्य</b></div>
                    <div><b>सम्पर्क नः </b>{row.ward_member_2_contact}</div>
                  </div>
                </GridItem>
                <GridItem xs={8} sm={4} md={2} style={{ marginLeft: 'auto', marginRight: 'auto', fontFamily: 'nepali-font' }}>
                  <Card style={{
                    marginBottom: '0', height: '100px',
                    backgroundColor: 'grey', backgroundImage: "url(" + row.ward_member_3_photo + ")",
                    backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}
                  />
                  <div style={{ padding: '10px' }}>
                    <div>{row.ward_member_3_name}</div>
                    <div><b>सदस्य</b></div>
                    <div><b>सम्पर्क नः </b>{row.ward_member_3_contact}</div>
                  </div>
                </GridItem>
                <GridItem xs={8} sm={4} md={2} style={{ marginLeft: 'auto', marginRight: 'auto', fontFamily: 'nepali-font' }}>
                  <Card style={{
                    marginBottom: '0', height: '100px',
                    backgroundColor: 'grey', backgroundImage: "url(" + row.ward_member_4_photo + ")",
                    backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }}
                  />
                  <div style={{ padding: '10px' }}>
                    <div>{row.ward_member_4_name}</div>
                    <div><b>सदस्य</b></div>
                    <div><b>सम्पर्क नः </b>{row.ward_member_4_contact}</div>
                  </div>
                </GridItem>
              </GridContainer>
            </Box>
            <TableCell><b>वडा सचिबः</b> {row.contact_person}</TableCell>
            <TableCell style={{fontFamily: 'nepali-font'}}><b>सम्पर्क नं.:</b> <span>{row.contact_number}</span></TableCell>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    count: PropTypes.number.isRequired,
    carbs: PropTypes.number.isRequired,
    fat: PropTypes.number.isRequired,
    data: PropTypes.arrayOf(
      PropTypes.shape({
        contactNumber: PropTypes.number.isRequired,
        contactPerson: PropTypes.string.isRequired,
        office: PropTypes.string.isRequired,
        website: PropTypes.string.isRequired,
      }),
    ).isRequired,
    name: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    protein: PropTypes.number.isRequired,
  }).isRequired,
};
const useStyles = makeStyles(styles);

export default function CollapsibleTable(props) {
  const classes = useStyles();

  const ward_offices_location = ()=> {return({
    'bhaktapur_ddc': API_BASE_URL + 'introduction/ward-office/?administrative_unit=bhaktapur_district',
    'changunarayan_municipality': API_BASE_URL + 'introduction/ward-office/?administrative_unit=changunarayan',
    'bhaktapur_municipality': API_BASE_URL + 'introduction/ward-office/?administrative_unit=bhaktapur',
    'madhyapur_thimi_municipality': API_BASE_URL + 'introduction/ward-office/?administrative_unit=madhyapur_thimi',
    'suryabinayak_municipality': API_BASE_URL + 'introduction/ward-office/?administrative_unit=suryabinayak',
  });}

  const municipality_name_map = {
    bhaktapur_ddc: {
      name: 'भक्तपुर जि.स.स.',
      second_name: 'भक्तपुर जि.स.स.'
    },
    changunarayan_municipality: {
      name: 'चाँगुनारायण नगर कार्यपालिका',
      second_name: 'चाँगुनारायण नगरपालिका'
    },
    bhaktapur_municipality: {
      name: 'भक्तपुर नगर कार्यपालिका',
      second_name: 'भक्तपुर नगरपालिका'
    },
    madhyapur_thimi_municipality: {
      name: 'मध्यपुर थिमि नगर कार्यपालिका',
      second_name: 'मध्यपुर थिमि नगरपालिका'
    },
    suryabinayak_municipality: {
      name: 'सूर्यविनायक नगर कार्यपालिका',
      second_name: 'सूर्यविनायक नगरपालिका'
    },
  }

  const [ward_detail, setWardOffice] = React.useState(undefined);

  React.useEffect(() => {
    if (ward_detail === undefined) {
      fetch(ward_offices_location()[props.selected_data])
        .then(results => results.json())
        .then(data => {
          setWardOffice(data.results);
        });
    }
  });

  const ward_row = (ward_detail) => ward_detail.map(unit_ward => {
        return ({
          'administrative_unit': unit_ward.administrative_unit,
          'ward': ward_name_map[unit_ward.ward],
          'contact_person': unit_ward.contact_person,
          'contact_number': unit_ward.contact_number,
          'location': unit_ward.location,
          'ward_chief_photo': unit_ward.ward_chief_photo,
          'ward_chief_name': unit_ward.ward_chief_name,
          'ward_chief_contact': unit_ward.ward_chief_contact,
          'ward_member_1_photo': unit_ward.ward_member_1_photo,
          'ward_member_1_name': unit_ward.ward_member_1_name,
          'ward_member_1_contact': unit_ward.ward_member_1_contact,
          'ward_member_2_photo': unit_ward.ward_member_2_photo,
          'ward_member_2_name': unit_ward.ward_member_2_name,
          'ward_member_2_contact': unit_ward.ward_member_2_contact,
          'ward_member_3_photo': unit_ward.ward_member_3_photo,
          'ward_member_3_name': unit_ward.ward_member_3_name,
          'ward_member_3_contact': unit_ward.ward_member_3_contact,
          'ward_member_4_photo': unit_ward.ward_member_4_photo,
          'ward_member_4_name': unit_ward.ward_member_4_name,
          'ward_member_4_contact': unit_ward.ward_member_4_contact
        });
      }
  )


  return (
    <div className={classes.section}>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <div style={{ color: "#134c7a", margin: 0}}>
            <small>जानकारी</small>
            <span><h3 className={classes.title} style={{ marginTop: '0px', color: '#134c7a'}}>{municipality_name_map[props.selected_data].second_name + 'का वडाहरुको परिचय'}</h3></span>
            <div style={{ width: '20px', borderBottom: "5px solid #134c7a", margin: 'auto' }}></div>
          </div>
          <GridContainer style={{margin: 'auto', color: '#333'}} xs={12} sm={12} md={10}>
            <div style={{ padding: '10px', width: '100%', margin: 'auto' }}>विस्तृत जानकारीको लागि तल वडा छान्नुहोस:</div>
            <TableContainer component={Paper} style={props.type !== 'municipality' ? { marginTop: '20px' }:{}}>
              <Table aria-label="collapsible table">
                <TableBody>
                  { props.selected_data !== 'bhaktapur_ddc' &&
                    ward_detail &&
                  ward_row(ward_detail).map((row, i) => (
                    <Row key={row.ward} row={row} type="municipality"/>
                  ))}
                  {ward_detail && ward_detail.length === 0 && <h3>उपलब्ध छैन</h3>}
                </TableBody>
              </Table>
            </TableContainer>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </div>

  );
}
